module.exports = __webpack_public_path__ + "fonts/TBCSailec-Black.a2cb078c.woff";